import * as react from "react";

export function backendVersionText(version_1) {
    switch (version_1.tag) {
        case 1:
            return "...";
        case 2:
            return version_1.fields[0];
        case 3:
            return version_1.fields[0];
        default:
            return "";
    }
}

export function version(model) {
    let children_4, children_8;
    const children_10 = [react.createElement("h2", {}, "Version"), (children_4 = [react.createElement("b", {}, "Frontend: "), model.ClientVersion], react.createElement("p", {}, ...children_4)), (children_8 = [react.createElement("b", {}, "Backend / API: "), backendVersionText(model.ServerVersion)], react.createElement("p", {}, ...children_8))];
    return react.createElement("div", {}, ...children_10);
}

export function view(model, dispatch, navigateTo) {
    let children_4, children_2, children;
    const children_6 = [(children_4 = [(children_2 = [(children = [version(model)], react.createElement("div", {
        className: "card-body",
    }, ...children))], react.createElement("div", {
        className: "flat-card profile-info-card is-auto",
    }, ...children_2))], react.createElement("div", {
        className: "column is-12",
    }, ...children_4))];
    return react.createElement("div", {
        className: "columns is-multiline",
    }, ...children_6);
}

//# sourceMappingURL=View.fs.js.map
